import { Notification } from 'types/notification';

export const initialState: NotificationState = {
  visibleNotification: null,
  notifications: []
};

export interface NotificationState {
  visibleNotification: Notification | null;
  notifications: Notification[];
}


// WEBPACK FOOTER //
// ./src/components/notification/state.ts